import React from 'react';
import { useState } from 'react';
import { Alert,Input,Card,CardContent,TextField } from '@mui/material';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { showNotification } from '../../../redux/slices/notificationSlice';
import CustomButton from '../../../componentsII/Buttons';
import api from '../../../axios/api';

// Define validation schema
const schema = yup.object().shape({
  sectorName: yup
    .string()
    .required('Sector name is required')
    .min(2, 'Sector name must be at least 2 characters long')
    .max(50, 'Sector name must be less than 50 characters')
    .trim()
});

const AddUpdateSectorModal = ({ onClose, refetch,sectorId = null, initialData = null }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const [error, setError] = useState('');
  const [sectorName, setSectorName] = useState(initialData?.sector_name || '');
  const [validationError, setValidationError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidationError('');
    setError('');

    try {
      // Validate using Yup schema
      await schema.validate({ sectorName }, { abortEarly: true });
      
      setIsSubmitting(true);
      
      const payload = {
        sectorId: sectorId || 0,
        sectorName: sectorName.trim()
      };

      const response = await api.post('/admin/CreateUpdateSector', payload);
      if (response.data.status == '200') {
        dispatch(showNotification({message:response.data.message,type: "success"}));
      }
      onClose();
      refetch();
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        setValidationError(err.message);
      } else {
        dispatch(showNotification({message:err.message,type: "error"}));
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e) => {
    setSectorName(e.target.value);
    setValidationError(''); // Clear validation error when user starts typing
  };

  return (
    <Card className="w-full mx-auto">
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="sectorName" className="text-sm font-medium">
              Sector Name
            </label>
            <TextField
              id="sectorName"
              value={sectorName}
              onChange={handleInputChange}
              placeholder="Enter sector name"
              disabled={isSubmitting}
              size='small'
              className={`w-full ${validationError ? 'border-red-500' : ''}`}
            />
            {validationError && (
              <p className="text-sm text-red-500 mt-1">{validationError}</p>
            )}
          </div>

          <div className="flex justify-end gap-5 items-center mt-5">
            <CustomButton
              className="bg-gray-500 hover:bg-gray-700 text-white"
              text="Cancel"
              click={onClose}
            />
            <CustomButton
              className="bg-green-600 hover:bg-green-700 text-white"
              text={sectorId ? "Update" : "Submit"}
              type="submit"
              disabled={isSubmitting}
            />
          </div>
        </form>
      </CardContent>
    </Card>
  );
};

export default AddUpdateSectorModal;